import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { FileText, Scale, Shield, Clock } from 'lucide-react';

const cgvSections = [
  {
    id: 1,
    title: "1. Identification du professionnel",
    content: "La société MONDIAGIMMO, EURL au capital de 1 000 €, immatriculée au RCS de Marseille sous le numéro 921 774 774, dont le siège social est situé 429 Boulevard Michelet – 13009 Marseille.\nTéléphone : 06 52 54 79 19\nEmail : mondiagimmo13@gmail.com",
    icon: FileText
  },
  {
    id: 2,
    title: "2. Champ d'application",
    content: "Les présentes Conditions Générales de Vente (CGV) s'appliquent à toutes les prestations de diagnostics immobiliers réalisées par le diagnostiqueur. Toute commande implique l'acceptation sans réserve des présentes CGV.",
    icon: Scale
  },
  {
    id: 3,
    title: "3. Prestations",
    content: "Les prestations sont réalisées conformément aux dispositions légales et réglementaires en vigueur. Le détail des prestations figure sur le devis remis au client préalablement à toute intervention.",
    icon: Shield
  },
  {
    id: 4,
    title: "4. Commande",
    content: "La commande devient ferme et définitive après acceptation écrite du devis par le client. Toute signature du devis engage le client au paiement de la prestation.",
    icon: FileText
  },
  {
    id: 5,
    title: "5. Prix",
    content: "Les prix sont indiqués en euros toutes taxes comprises. Le prix facturé est celui figurant sur le devis accepté.",
    icon: FileText
  },
  {
    id: 6,
    title: "6. Modalités de paiement",
    content: "Les modalités de paiement sont précisées sur le devis. Le diagnostiqueur se réserve le droit de suspendre la remise des rapports en cas de non-paiement.",
    icon: FileText
  },
  {
    id: 7,
    title: "7. Délais d'exécution",
    content: "Les délais d'intervention et de remise des rapports sont indiqués sur le devis. Ils peuvent varier selon la nature de la prestation, les contraintes techniques ou les informations transmises par le client.",
    icon: Clock
  },
  {
    id: 8,
    title: "8. Obligations du client",
    content: "Le client s'engage à fournir toutes les informations nécessaires à la bonne exécution de la prestation et à garantir l'accès aux locaux. Toute information erronée engage sa responsabilité.",
    icon: Shield
  },
  {
    id: 9,
    title: "9. Responsabilité",
    content: "Le Diagnostiqueur est soumis à une obligation de moyens. Sa responsabilité ne peut être engagée qu'en cas de faute prouvée et est limitée aux dommages matériels directs, dans les limites autorisées par la réglementation applicable.",
    icon: Shield
  },
  {
    id: 10,
    title: "10. Droit de rétractation",
    content: "Conformément aux articles L.221-18 et suivants du Code de la consommation, le client consommateur dispose d'un délai de quatorze (14) jours à compter de la conclusion du contrat pour exercer son droit de rétractation sans motif. Lorsque le client demande l'exécution de la prestation avant la fin du délai de rétractation, il reconnaît expressément perdre son droit de rétractation si la prestation est pleinement exécutée. En cas de rétractation après le début de la prestation, un montant proportionnel aux prestations réalisées sera dû.",
    icon: Scale
  },
  {
    id: 11,
    title: "11. Données personnelles",
    content: "Les données personnelles sont collectées uniquement pour la gestion des prestations. Conformément au RGPD, le client dispose d'un droit d'accès, de rectification et de suppression.",
    icon: Shield
  },
  {
    id: 12,
    title: "12. Droit applicable et litiges",
    content: "Les présentes CGV sont soumises au droit français. En cas de litige, une solution amiable sera recherchée avant toute action judiciaire.",
    icon: Scale
  }
];

export const CGV = () => {
  return (
    <section id="cgv" className="py-32 bg-gradient-to-br from-stone-50 via-white to-stone-50">
      <div className="max-w-5xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16 space-y-6">
          <div className="inline-flex items-center gap-2 text-emerald-700 mb-4">
            <div className="w-12 h-[2px] bg-emerald-700" />
            <span className="text-sm uppercase tracking-widest font-medium">Informations Légales</span>
            <div className="w-12 h-[2px] bg-emerald-700" />
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold text-stone-900">
            Conditions Générales de Vente
          </h1>
          
          <p className="text-xl text-stone-600 max-w-2xl mx-auto">
            MONDIAGIMMO - Diagnostics Immobiliers à Marseille
          </p>
        </div>

        {/* CGV Content */}
        <div className="space-y-6">
          {cgvSections.map((section, index) => {
            const Icon = section.icon;
            return (
              <Card 
                key={section.id}
                className="border-stone-200 hover:border-emerald-300 transition-all duration-300 hover:shadow-lg"
              >
                <CardHeader>
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-100 to-emerald-50 flex items-center justify-center flex-shrink-0">
                      <Icon className="w-6 h-6 text-emerald-700" />
                    </div>
                    <CardTitle className="text-2xl font-bold text-stone-900 pt-2">
                      {section.title}
                    </CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-stone-600 leading-relaxed whitespace-pre-line pl-16">
                    {section.content}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Footer note */}
        <div className="mt-16 text-center">
          <div className="inline-block px-8 py-6 bg-emerald-50 rounded-2xl border-2 border-emerald-200">
            <p className="text-stone-700 font-medium mb-2">
              Dernière mise à jour : Janvier 2025
            </p>
            <p className="text-stone-600 text-sm">
              Pour toute question concernant nos CGV, contactez-nous au 06 52 54 79 19
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
